import { selectors } from '@hixme/auth-ui'
import { storeInstance } from 'store/createStore'

export default ({ allowedRoles, callback }) => {
  // @ts-ignore
  const state = storeInstance?.getState?.()
  // @ts-ignore
  const isAuthenticated = selectors.isAuthenticated(state)
  // @ts-ignore
  const role = selectors.getRole(state)

  if (!isAuthenticated) {
    const error = { status: 401, message: 'not authenticated' }
    callback(error)
    return
  }

  if (!allowedRoles.includes(role)) {
    const error = { status: 401, message: 'not authorized' }
    callback(error)
    return
  }

  callback()
}
